export const REQUIRED_BUSINESS_CONFIG_DOCUMENT_IDS = [
  'businessInfo',
  'homepage',
  'features',
] as const;

export const findMissingRequiredBusinessConfigDocuments = (
  documentIds: Iterable<string>
): string[] => {
  const availableDocumentIds = new Set(documentIds);
  return REQUIRED_BUSINESS_CONFIG_DOCUMENT_IDS.filter(
    (documentId) => !availableDocumentIds.has(documentId)
  );
};
